
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from "sonner";
import analytics from '@/utils/analytics';

const SettingsTab = () => {
  const [symptoms, setSymptoms] = useState<string[]>([
    "Fatigue", "Headache", "Bloating", "Cramps", 
    "Mood Swings", "Insomnia", "Low Energy", "Cravings"
  ]);
  const [newSymptom, setNewSymptom] = useState('');

  const handleAddSymptom = () => {
    if (newSymptom.trim()) {
      setSymptoms([...symptoms, newSymptom.trim()]);
      setNewSymptom('');
      toast.success(`Added symptom: ${newSymptom}`);
      analytics.trackUserAction('admin_add_symptom', { symptom: newSymptom });
    }
  };
  
  const handleRemoveSymptom = (symptom: string) => {
    setSymptoms(symptoms.filter(s => s !== symptom));
    toast.success(`Removed symptom: ${symptom}`);
    analytics.trackUserAction('admin_remove_symptom', { symptom });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Symptom Options</CardTitle>
        <CardDescription>
          Manage the list of symptoms that users can select from
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Input
              placeholder="Add new symptom..."
              value={newSymptom}
              onChange={(e) => setNewSymptom(e.target.value)}
              className="flex-1"
            />
            <Button onClick={handleAddSymptom} disabled={!newSymptom.trim()}>
              Add
            </Button>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
            {symptoms.map((symptom) => (
              <div
                key={symptom}
                className="flex items-center justify-between p-2 rounded-lg border border-hormony-beige/50 bg-white"
              >
                <span className="text-sm">{symptom}</span>
                <button 
                  onClick={() => handleRemoveSymptom(symptom)}
                  className="text-red-500 hover:text-red-700 transition-colors"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SettingsTab;
